module.exports = __webpack_public_path__ + "media/notice10.6d2e9a0b.mp3";